<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#9CA3AF' },
})
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM6.25 7.5C6.25 6.80964 6.80964 6.25 7.5 6.25C8.19036 6.25 8.75 6.80964 8.75 7.5V12.5C8.75 13.1904 8.19036 13.75 7.5 13.75C6.80964 13.75 6.25 13.1904 6.25 12.5V7.5ZM12.5 6.25C11.8096 6.25 11.25 6.80964 11.25 7.5V12.5C11.25 13.1904 11.8096 13.75 12.5 13.75C13.1904 13.75 13.75 13.1904 13.75 12.5V7.5C13.75 6.80964 13.1904 6.25 12.5 6.25Z"
      :fill="fillColor"
    />
  </svg>
</template>
